module.exports = __webpack_public_path__ + "static/img/QA.a055d22b.jpg";